<!-- SECTION 1: HERO HEADER -->
<section class="hero wave-bg">
  <div class="container hero-content">
    <div class="hero-text">
      <div class="inline-flex items-center gap-3 bg-white/5 text-foreground border border-white/20 px-4 py-2 rounded-full font-semibold text-sm mb-6 backdrop-blur-sm">
        <svg class="rounded-sm shadow-sm flex-shrink-0" viewBox="0 0 3 2" width="20" height="15">
          <rect width="1" height="2" x="0" fill="#002395"/>
          <rect width="1" height="2" x="1" fill="#ffffff"/>
          <rect width="1" height="2" x="2" fill="#ed2939"/>
        </svg>
        100% Made in France - Pas d'offshore
      </div>
      <app-cii-badge variant="inline" />
      <h1>
        Votre application métier critique vous coûte cher <span class="accent">chaque jour de downtime ou bug</span>
      </h1>
      <p class="hero-description">
        Arrêtez l'hémorragie de CA : on sécurise uptime 99.9%, réduit dette tech -60% et intervient en &lt;72h.
        <br>
        <strong>Expertise senior 100% France (Paris / Châteauroux) : Node.js, Angular, React & Android.</strong>
      </p>
      
      <ul class="hero-bullets">
        <li>✅ Évitez pertes CA par minute d'indisponibilité</li>
        <li>✅ Réparation bugs urgents sans tout recoder</li>
        <li>✅ Création apps scalables sans risque offshore</li>
      </ul>

      <div class="cta-row">
        <a
          href="https://cal.mesh-box.fr/ogirodin/30min"
          target="_blank"
          rel="noopener"
          class="button primary large"
        >
          Diagnostic gratuit (30 min) – Calculer mon ROI
        </a>
        <button
          (click)="scrollToRoi()"
          class="button large outline"
          style="background: transparent; border: 1px solid var(--border); color: var(--text); cursor: pointer;"
        >
          Calculateur ROI
        </button>
        <a href="/simulateur-cii" class="button large outline">
          🏛️ Calculer mon crédit d'impôt →
        </a>
      </div>
    </div>
    
    <!-- Hero Visual / ROI Teaser (Desktop) -->
    <div class="hero-trust mobile-hidden">
      <div class="mini-stat-card bounce-in">
        <div class="stat-icon">📉</div>
        <div class="stat-info">
          <strong>-60%</strong>
          <span>Dette Technique</span>
        </div>
      </div>
      <div class="mini-stat-card bounce-in delay-1">
        <div class="stat-icon">⚡</div>
        <div class="stat-info">
          <strong>99.9%</strong>
          <span>Uptime Garanti</span>
        </div>
      </div>
      
      <p style="margin-top: 2rem; font-size: 0.9rem; opacity: 0.8;">Ils nous font confiance :</p>
      <div class="trust-logos">
        <img src="/assets/logos/ingenico.svg" alt="Ingenico" class="client-logo client-logo-ingenico" width="240" height="120" />
        <img src="/assets/logos/bouygues.svg" alt="Bouygues Telecom" class="client-logo" width="120" height="60" />
        <img src="/assets/logos/citroen.png" alt="Citroën / PSA" class="client-logo" width="120" height="60" />
      </div>
    </div>
  </div>
</section>

<!-- SECTION 2: ROI CALCULATOR -->
<section class="section alt" id="roi-calculator">
  <div class="container">
    <div class="intro-container">
      <h2 style="text-align: center; margin-bottom: 1rem;">
        Combien vous coûte votre Dette Technique ?
      </h2>
      <p class="intro-text" style="text-align: center; margin-bottom: 2rem;">
        Chaque heure de bug ou d'indisponibilité impacte votre marge. Utilisez notre calculateur pour estimer vos économies potentielles avec une maintenance pro-active.
      </p>
    </div>
    
    <!-- The Angular Component -->
    <app-roi-calculator></app-roi-calculator>

  </div>
</section>

<!-- SECTION 3: NOS 2 PILIERS (SERVICES) -->
<section class="section">
    <div class="container">
        <h2 style="text-align: center; margin-bottom: 3rem;">Nos 2 Piliers d'Intervention</h2>
        
        <div class="grid-2 gap-large">
          <!-- Pilier 1 : Création -->
          <div class="card highlight-hover">
            <div class="card-icon">🚀</div>
            <h3>1. Création d'Apps Métier Scalables</h3>
            <p class="service-desc">Pour les projets ambitieux qui doivent supporter une forte charge dès le lancement.</p>
            <ul class="check-list">
              <li>Architectures <strong>Node.js / NestJS</strong> haute performance</li>
              <li>Front-ends <strong>Angular / React / Android</strong></li>
              <li>Intégration <strong>IA & Data</strong> (RAG, Prédictif)</li>
              <li>Sécurité & RGPD by Design (Serveurs France)</li>
            </ul>
            <div class="mt-3">
              <app-cii-badge variant="compact" />
            </div>
            <a href="/contact" class="link-arrow">Lancer mon projet</a>
          </div>
    
          <!-- Pilier 2 : Maintenance -->
          <div class="card highlight-hover">
            <div class="card-icon">🛠️</div>
            <h3>2. Maintenance & Sauvetage (TMA)</h3>
            <p class="service-desc">Votre application est lente, buggée ou le développeur précédent est parti ?</p>
            <ul class="check-list">
              <li><strong>Audit Flash</strong> & Réparation de bugs critiques</li>
              <li>Refactoring progressif (sans tout recoder)</li>
              <li>Mise à jour des dépendances (Sécurité)</li>
              <li>Astreinte & Monitoring pro-actif</li>
              <li>TMA spécialisée : <a href="/tma-nodejs" style="color: var(--brand);">Node.js</a> • <a href="/tma-angular" style="color: var(--brand);">Angular</a> • <a href="/tma-android" style="color: var(--brand);">Android</a></li>
            </ul>
            <div class="mt-3">
              <app-cii-badge variant="compact" />
            </div>
            <a href="/maintenance-tma-nodejs-angular" class="link-arrow">Sauver mon application</a>
          </div>
        </div>
    </div>
</section>

<!-- SECTION 4: POURQUOI NOUS (Made in France) -->
<section class="section alt">
  <div class="container">
    <div class="grid-2" style="align-items: center; gap: 4rem;">
       <div class="reveal">
        <h2 style="margin-bottom: 1.5rem;">Agence 100% Made in France 🇫🇷 <br><span class="text-muted" style="font-size: 0.7em;">Zéro Offshore, Zéro Compromis</span></h2>
        <p style="margin-bottom: 1.5rem; font-size: 1.1rem; line-height: 1.6;">
          Contrairement à de nombreuses agences qui sous-traitent à bas coût, <strong>l'intégralité de votre code est produite en France</strong>, entre Paris et Châteauroux.
        </p>
        <p style="margin-bottom: 2rem;">
          Cela garantit :
        </p>
        <ul class="check-list large-text">
            <li>✅ Une compréhension fine de vos enjeux business</li>
            <li>✅ Une qualité de code premium (Senior only)</li>
            <li>✅ Une protection juridique et RGPD totale</li>
            <li>✅ Des horaires de travail alignés sur les vôtres</li>
        </ul>
        <a href="https://cal.mesh-box.fr/ogirodin/30min" target="_blank" class="button primary">
          Parler à un expert Français
        </a>
      </div>
      <div class="reveal illustration-container">
        <img
          src="/assets/section-expertises-collab.jpg"
          data-fallback="/assets/section-expertises-collab.svg"
          alt="Équipe Mesh-Box France"
          style="width: 100%; border-radius: 12px; box-shadow: var(--shadow);"
          loading="lazy"
        />
        <div class="floating-badge">
            <span>📍 Châteauroux & Paris</span>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- SECTION 5: METHODOLOGIE -->
<section id="methode" class="section">
  <div class="container">
    <h2 style="text-align: center; margin-bottom: 3rem;">Le Protocole "Sérénité Intégrale"</h2>
    
    <div class="process grid-4">
      <div class="card reveal step-card">
        <div class="step-number">1</div>
        <h4>Audit & Diagnostic</h4>
        <p>On analyse le code existant ou le cahier des charges. On identifie les risques avant de coder.</p>
      </div>

      <div class="card reveal step-card">
        <div class="step-number">2</div>
        <h4>Architecture Solide</h4>
        <p>Choix de la stack technique (Node, Angular, Android, Python...) adaptée à VOTRE besoin, pas à nos préférences.</p>
      </div>

      <div class="card reveal step-card">
        <div class="step-number">3</div>
        <h4>Dév & Tests Auto</h4>
        <p>Chaque fonctionnalité est testée automatiquement. 0 régression garantie lors des mises à jour.</p>
      </div>

      <div class="card reveal step-card">
        <div class="step-number">4</div>
        <h4>Maintenance (TMA)</h4>
        <p>On ne vous abandonne pas. Monitoring 24/7 et interventions rapides en cas de pépin.</p>
      </div>
    </div>
  </div>
</section>

<!-- SECTION 6: STACK TECHNO -->
<section class="section" style="padding: 3rem 0; border-top: 1px solid var(--border); background: var(--bg-alt);">
  <div class="container">
    <p class="stack-section-title">
      Experts sur les technologies modernes
    </p>
    <app-advanced-tech-stack></app-advanced-tech-stack>
  </div>
</section>


<!-- SECTION 7: TEMOIGNAGES -->
<section id="temoignages" class="section wave-bg">
    <div class="container">
        <h2 style="text-align: center;">Ils dorment mieux la nuit</h2>
        <p class="intro-text" style="text-align: center; margin-bottom: 3rem;">Retours d'expérience de nos partenaires</p>
        <div class="grid-3">
            <div class="card reveal">
                <blockquote>
                    <p>"Mesh-Box a repris notre plateforme legacy qui crashait tous les jours. En 2 mois, plus aucun incident et l'app est 3x plus rapide."</p>
                    <footer>
                        <strong>Directeur Technique</strong>
                        <span class="role">Retail / E-commerce</span>
                    </footer>
                </blockquote>
            </div>
            <div class="card reveal">
                <blockquote>
                    <p>"Enfin une agence qui parle business et pas juste 'code'. Ils ont compris nos enjeux de scalabilité pour notre levée de fonds."</p>
                    <footer>
                        <strong>Fondateur</strong>
                        <span class="role">Fintech Série A</span>
                    </footer>
                </blockquote>
            </div>
            <div class="card reveal">
                <blockquote>
                    <p>"Le Made in France fait la différence. Communication fluide, code propre, documentation nickel. On continue avec eux en TMA."</p>
                    <footer>
                        <strong>DSI</strong>
                        <span class="role">Groupe Industriel</span>
                    </footer>
                </blockquote>
            </div>
        </div>
    </div>
</section>

<!-- SECTION 8: FAQ & CTA FINAL -->
<section id="contact" class="section cta-final alt">
  <div class="container">
    <div class="cta-box">
        <h2>Prêt à sécuriser votre business ?</h2>
        <p>Ne laissez plus la dette technique ralentir votre croissance.</p>
        
        <div class="cta-actions">
            <a
                href="https://cal.mesh-box.fr/ogirodin/30min"
                target="_blank"
                rel="noopener"
                class="button primary large pulse"
            >
                📅 Réserver mon Audit Gratuit
            </a>
            <p class="small-note">30 min de visio • Sans engagement • Expert Senior</p>
            <div class="mt-4 flex justify-center">
              <app-cii-badge variant="compact" />
            </div>
        </div>

        <div class="contact-infos">
            <p>Ou contactez-nous directement :</p>
            <a href="mailto:contact@mesh-box.fr">contact@mesh-box.fr</a>
        </div>
    </div>
  </div>
</section>